import React from "react";
import TypeForm from "react-typeform";
import { Card } from "antd";
import { Alert } from "reactstrap";
import Navigation from "../components/Navigation";

import Step1 from "../components/step1";
import Step2 from "../components/step2";
import Step3 from "../components/step3";
import Step4 from "../components/step4";
import Step5 from "../components/step5";
import AppLogic from "../Logic/App/AppLogic";
import { Auth } from "../config/firebase";
import { Redirect } from "react-router";

class Startup extends React.Component {
  state = {
    description: "",
    link1: "",
    link2: "",
    link3: "",
    link4: "",
    github1: "",
    linkind1: "",
    github2: "",
    linkind2: "",
    priorities: [],
    isLoadingtTEXT: "",
    isLoading: false,
    isError: false,
    error: "",
  };

  submit = () => {
    const {
      github1,
      linkind1,
      github2,
      linkind2,
      link1,
      link2,
      link3,
      link4,
      priorities,
      description,
    } = this.state;
    const user = Auth.currentUser;
    if (github1 == "" || linkind1 == "") {
      if (description == "") {
        this.setState({
          isError: true,
          error: "What are you working on field is empty",
        });
        return;
      }

      this.setState({
        isError: true,
        error: "Founders github or LinkedIn is missing",
      });
      return;
    }

    if (link1 == "") {
      this.setState({
        isError: true,
        error: "We need at least one url to the project",
      });
      return;
    }

    if (priorities.length < 1) {
      this.setState({
        isError: true,
        error: "Pick at least one immediate priorities",
      });
      return;
    }

    this.setState({ isLoadingtTEXT: "...Procesing", isLoading: true });
    const data = {
      description,
      priorities,
      demoLinks: [link1, link2, link3, link4],
      founderOne: { github: github1, linkind: linkind1 },
      founderTwo: { github: github2, linkind: linkind2 },
      isUser: user ? user.uid : null,
    };

    AppLogic.saveStartUp(data)
      .then((res) =>
        this.setState({ isLoadingtTEXT: "success", isLoading: true }),
        this.props.history.push("/")
      )
      .catch((e) => this.setState({ error: e.message, isLoading: false }));
  };
  handleChange = (item, value) => {
    this.setState({ [item]: value });
  };

  handleCheckBox = (prior, check) => {
    if (check) {
      this.setState((prevState) => ({
        priorities: [...prevState.priorities, prior],
      }));
    } else {
      this.setState((prevState) => ({
        priorities: prevState.priorities.filter((res) => res != prior),
      }));
    }
  };
  onDismiss = () => {
    this.setState((prevState) => ({ isError: !prevState.isError }));
  };

  onDismissX = () => {
    this.setState((prevState) => ({ isLoading: !prevState.isLoading }));
  };
  render() {
    console.log(this.state.priorities);
    const {
      github1,
      linkind1,
      github2,
      linkind2,
      isLoading,
      isLoadingtTEXT,
      isError,
      error,
    } = this.state;
    return (
      <>
        <Navigation />
        {/* {this.props.history.location.pathname} */}
        
        <div className="col-md-8 mt-5 mr-auto ml-auto">
          <Card bordered={false} style={{ width: "100%" }}>
          <Alert color="primary" isOpen={isLoading} toggle={this.onDismissX}>
          {isLoadingtTEXT}
        </Alert>

        <Alert color="danger" isOpen={isError} toggle={this.onDismiss}>
          {error}
        </Alert>

            <TypeForm
              backBtnClass="btn btn-secondary"
              submitBtnClass="btn btn-primary"
              showReviewView={false}
              onSubmit={this.submit}
              submitBtnText="submit"
              nextBtnClass="btn btn-primary pull-right"
            >
              <Step1 change={this.handleChange} />
              <Step2 change={this.handleChange} />
              <Step3 change={this.handleChange} />
              <Step4
                change={this.handleChange}
                link1={github1}
                link2={linkind1}
                link3={github2}
                link4={linkind2}
              />
              <Step5 change={this.handleCheckBox} />
            </TypeForm>
          </Card>
        </div>
      </>
    );
  }
}

export default Startup;
